/**
 * Converts an object to FormData, handling nested objects and arrays
 * @param {Object} obj - The object to convert
 * @param {FormData} formData - Optional existing FormData instance
 * @param {string} parentKey - Optional parent key for nested objects
 * @returns {FormData} The FormData instance
 */
export function objectToFormData(obj, formData = new FormData(), parentKey = '') {
    if (obj === null || obj === undefined) {
        return formData;
    }

    for (const key in obj) {
        if (Object.hasOwn(obj, key)) {
            const value = obj[key];
            const formKey = parentKey ? `${parentKey}[${key}]` : key;

            if (value instanceof File || value instanceof Blob) {
                formData.append(formKey, value);
            } else if (value instanceof Date) {
                formData.append(formKey, value.toISOString());
            } else if (Array.isArray(value)) {
                value.forEach((item, index) => {
                    const arrayKey = `${formKey}[${index}]`;
                    if (
                        typeof item === 'object' &&
                        !(item instanceof File) &&
                        !(item instanceof Blob)
                    ) {
                        objectToFormData(item, formData, arrayKey);
                    } else {
                        formData.append(arrayKey, item);
                    }
                });
            } else if (typeof value === 'object' && value !== null) {
                objectToFormData(value, formData, formKey);
            } else {
                formData.append(formKey, value);
            }
        }
    }

    return formData;
}
